import React from 'react';

export const EmptyDataIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="207"
    height="210"
    viewBox="0 0 207 210"
  >
    <defs>
      <linearGradient
        id="linearGradient-1"
        x1="19.823%"
        x2="124.189%"
        y1="65.807%"
        y2="65.807%"
      >
        <stop offset="0%" stopColor="#FF9A6B" />
        <stop offset="100%" stopColor="#FF7E80" />
      </linearGradient>
      <linearGradient
        id="linearGradient-2"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#320056" />
        <stop offset="100%" stopColor="#320056" />
      </linearGradient>
      <linearGradient
        id="linearGradient-3"
        x1="19.823%"
        x2="124.189%"
        y1="65.807%"
        y2="65.807%"
      >
        <stop offset="0%" stopColor="#D3D2F4" />
        <stop offset="100%" stopColor="#FF7E80" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-582 -311)">
        <g transform="translate(532 266)">
          <path
            fill="#EBEAF9"
            d="M222.074 201.763c-27.908 21.066-11.685 66.7-67.077 63.028-34.378-2.279-40.387-35.939-53.066-46.367-15.994-13.155-45.467-1.63-55.159-34.422-7.683-25.996 11.357-32.933 23.805-44.398 17.497-16.115 7.434-42.432 20.86-70.84 13.428-28.41 88.182-36.546 107.867 12.983 12.052 30.323 52.9 9.94 64.952 52.849 12.052 42.908-18.078 48.973-42.182 67.167z"
            transform="rotate(40 156 155.5)"
          />
          <path
            fill="url(#linearGradient-1)"
            d="M88.6641257 72.149231L198.096889 72.1081886 198.044446 211.650769 88.6116826 211.691811z"
            transform="rotate(8 143.354 141.9)"
          />
          <path
            fill="#FFF"
            d="M79.08 81.6666667L152.908571 81.6666667 182.44 111.191111 182.44 215.133333 79.08 215.133333z"
          />
          <path
            fillRule="nonzero"
            d="M151.406685 112.394073L151.406685 83.2687088 150.583824 83.2687088 150.583824 113.268709 179.583824 113.268709 179.583824 112.394073z"
          />
          <path d="M215.222983 215.976656L251.766445 215.976656 251.766445 252.91563 215.222983 252.91563z" />
          <path
            fill="#EBEAF9"
            d="M93.584 124.269h75a1 1 0 011 1v9a1 1 0 01-1 1h-75a1 1 0 01-1-1v-9a1 1 0 011-1zM93.584 143.269h75a1 1 0 011 1v9a1 1 0 01-1 1h-75a1 1 0 01-1-1v-9a1 1 0 011-1zM93.584 162.269h75a1 1 0 011 1v9a1 1 0 01-1 1h-75a1 1 0 01-1-1v-9a1 1 0 011-1z"
          />
          <path
            fill="url(#linearGradient-2)"
            d="M221.72 213.356c-.092-.092-1.213-.126-1.68 0-3.77 1.023-7.178 5.843-5.686 2.138 1.493-3.706-5.425 1.778-1.914 6.942.2.293 2.736 2.898 2.816 2.978l1.566 1.584c5.27 5.326 13.173 13.316 23.711 23.97a6.53 6.53 0 009.306 0c2.57-2.599 2.57-6.81 0-9.408l-28.12-28.204z"
          />
          <path
            fill="url(#linearGradient-3)"
            d="M191.965 161.89c-16.988 0-30.76 13.771-30.76 30.76 0 16.988 13.772 30.76 30.76 30.76s30.76-13.772 30.76-30.76c0-16.989-13.772-30.76-30.76-30.76"
          />
          <path
            fill="#FFF"
            d="M167.86 194.86a1.944 1.944 0 01-1.943-1.944c0-15.517 12.624-28.141 28.14-28.141a1.944 1.944 0 010 3.888c-13.372 0-24.252 10.88-24.252 24.253 0 1.074-.87 1.944-1.944 1.944"
          />
          <path
            fill="#320056"
            d="M191.965 223.41c-16.988 0-30.76-13.772-30.76-30.76s13.772-30.76 30.76-30.76 30.76 13.772 30.76 30.76-13.772 30.76-30.76 30.76zm28.273-8.72c.045-.046.096-.082.146-.12a35.734 35.734 0 007.476-21.92c0-19.825-16.07-35.895-35.895-35.895-19.824 0-35.895 16.07-35.895 35.895 0 19.824 16.07 35.895 35.895 35.895a35.721 35.721 0 0021.84-7.424l4.153-4.152 2.28-2.28z"
          />
        </g>
      </g>
    </g>
  </svg>
);
